import React from "react";
import MedicationSummaryPriceCard from "./medication-summary-price-card";
import {MedicationSummary} from "../types";

export interface MedicationSummaryCardProps {
    medicationSummary: MedicationSummary
}

const MedicationSummaryCard = ({medicationSummary}: MedicationSummaryCardProps) => {
    return (
        <pui-card padding="none" fullwidth>
            <pui-section class="medication-info" flowDirection="vertical" fullWidth>
                <pui-text class="medication-intake" input={medicationSummary.label} spacingbottom="med-small"/>
                <pui-heading input={medicationSummary.heading} spacingbottom="mini"/>
                <pui-text class="medication-attributes" input={medicationSummary.subheading}/>
            </pui-section>
            <MedicationSummaryPriceCard basisPrice={medicationSummary.basisPrice} priceToPay={medicationSummary.priceToPay}
                                        saving={medicationSummary.saving}/>
            <pui-text class="medication-variation" input={medicationSummary.description} fontstyle="italic"/>
        </pui-card>
    )
}

export default MedicationSummaryCard;